import React from 'react';
import { Breadcrumb } from 'antd';
import { useLocation } from 'react-router-dom';

type ItemType = {
  link: string;
  name: string;
}

interface Props {
  item: ItemType[];
}

const CustomBreadCrumb = ({ item }: Props) => {
  const location = useLocation();

  const breadcrumbItems = item.map((e: ItemType) => {
    const active = e.link === location.pathname;
    return {
      title: (
        <a href={e.link} className={`text-sm ${active ? '!text-gray-800 font-semibold' : 'text-gray-400'}`}>
          {e.name}
        </a>
      ),
      key: e.link
    };
  });

  return (
    <div className='mb-4'>
      <Breadcrumb items={breadcrumbItems} />
    </div>
  );
}

export default CustomBreadCrumb;
